<template>
	<div class="bg-white p-5 m-10">
		<div class="f-s-17 black">{{xgTheme.productTitle}}<span class="pink w-550"
				v-if="xgTheme.productSubTitle != null && xgTheme.productSubTitle !=''">({{xgTheme.productSubTitle}})</span>
		</div>
		<van-divider />
		<div class="flex p-b-6" v-for="(item,index) in productList" :key="index">
			<div class="porduct-image-div">
				<img :src="item.productImg" />
				<!-- <div class="image-price pink w-550">
					<span class="f-s-8">¥</span>
					<span class="f-s-14">{{item.productPrice}}</span>
					<span class="f-s-12">元</span>
				</div> -->
			</div>
			<div class="porduct-detail-div">
				<div class="f-s-18 black w-500">{{item.productName}}</div>
				<div class="f-s-13 w-500" :class="{'yellow':canPay(),'red':!canPay()}" v-if="xgUserInfo.isImpower==1">
					{{canPay()?'积分充足可兑换':'积分不足'}}
				</div>
				<div class="p-t-6">
					<span class="f-s-12 pink">{{item.cyPoints|toCmssScore}}移动积分</span>
					<span class="f-s-12 gray">(={{item.cyPoints}}畅由积分)</span>
				</div>
			</div>
			<div class="add-div">
				<van-stepper v-model="item.count" @change="changePrice(index)" theme="round" min="0"
					:max="item.reserved3?item.reserved3:100" default-value="0" button-size="60px" disable-input
					:disabled="isDisabled(item.id)" />
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex"
	import {
		getProduct,
		getCmccPower
	} from '@/request/api'
	export default {
		name: 'Product',
		computed: mapGetters(['xgUserInfo', 'xgTheme']),
		data() {
			return {
				productList: [],
			}
		},
		created() {
			this.initProduct()
		},
		methods: {
			canPay() {
				//所需畅游积分
				let price = this.getPrice()
				//移动积分最大可转的畅游积分
				let maxCyScore = Math.floor(this.xgUserInfo.cmccScore / 120) * 100
				return maxCyScore >= price || this.xgUserInfo.cyScore >= price
			},
			initProduct() {
				getCmccPower({

				}).then(res => {
					getProduct({
						providerCode: this.xgUserInfo.providerCode,
						pageNo: 1,
						pageSize: 1000
					}).then(res => {
						if (res.records) {
							this.productList = res.records
							//计算价格
							this.changePrice()
						}
					})
				})
			},
			isDisabled(id) {
				for (let item of this.productList) {
					if (item.count > 0 && item.id != id) {
						return true
					}
				}
				return false
			},
			recommendNumber(index) {
				if (this.xgUserInfo.providerCode != 'bianfeng') {
					return
				}
				if (!this.xgUserInfo.cmccScore) {
					return
				}
				if (index == null) {
					return
				}
				if (this.productList[index].first && this.productList[index].first == true) {
					return
				}

				let cmssPoints = parseInt(this.productList[index].cyPoints) * 1.2
				let count = Math.floor(this.xgUserInfo.cmccScore / cmssPoints)
				if (count > 0) {
					let productList = this.productList
					productList[index].count = count
					productList[index].first = true
					this.productList = productList
				}
			},
			changePrice(index) {
				this.recommendNumber(index)
				this.$emit("changePrice", this.getPrice())
				this.$emit("changeProduct", this.getSelectProduct())
			},
			getPrice() {
				return this.productList.reduce(function(prev, cur) {
					return prev + cur.count * cur.cyPoints;
				}, 0)
			},
			getSelectProduct() {
				let product = []
				for (let item of this.productList) {
					if (item.count < 1) {
						continue
					}
					product.push({
						productId: item.id,
						num: item.count,
						reserved1: item.reserved1,
						reserved2: item.reserved2
					})
				}
				return product
			}
		}
	}
</script>

<style scoped>
	.porduct-image-div {
		width: 90px;
		height: 90px;
		padding: 0px 5px;
		position: relative;
	}

	.porduct-image-div img {
		width: 100%;
	}

	.porduct-detail-div {
		flex: 1;
	}

	.add-div {
		display: flex;
		align-items: flex-end;
		margin-left: auto;
		height: 70px;
	}

	.image-price {
		position: absolute;
		bottom: 28px;
		left: 24px;
	}



	.add-div /deep/ .van-stepper__plus {
		width: 18px !important;
		height: 18px !important;
		background-color: #f5d448;
	}

	.add-div /deep/ input {
		height: 18px !important;
	}

	.add-div /deep/ .van-stepper__minus {
		width: 18px !important;
		height: 18px !important;
		border-color: #f5d448;
		color: #f5d448;
	}
</style>
